import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import Footer from "../components/Footer"
import Main from "../components/Home/Main"



const HomeScreen = () => {
    return (
        <>
            <Navbar />
            <Hero ></Hero>
            <main className='main-wrap'>
                <Main />
            </main>
            <Footer></Footer>
        </>
    );
}

export default HomeScreen;
